import React, { useRef, useEffect, useState } from 'react';
import { Container, Modal, Button } from 'react-bootstrap';
// import Header from './components/Header';
import ProductCarousel from './components/ProductCarousel';
import ProductSelector from './components/ProductSelector';
import EnergyStats from './components/EnergyStats';
import EquipmentList from './components/EquipmentList';
import equipmentData from './data/equipmentData';
import preselectedEquipment from './data/preselectedEquipmentData';
import HeroSection from './components/HeroSection';
import './styles/App.css';
import BackToTop from './components/BackToTop';
import Contact from './components/Contact';
import ContactIcon from './components/ContactIcon';
import Quote from './components/Quote';

function App() {
  const [selectedProduct, setSelectedProduct] = useState(equipmentData.products[0]);
  const [consumption, setConsumption] = useState(0);
  const [selectedEquipment, setSelectedEquipment] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingProduct, setPendingProduct] = useState(null);
  const [showContactForm, setShowContactForm] = useState(false);
  const [showQuoteForm, setShowQuoteForm] = useState(false);
  const productCarouselRef = useRef(null);

  const scrollToCarousel = () => {
    if (productCarouselRef.current) {
      productCarouselRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const loadDefaultEquipments = (product) => {
    const config = preselectedEquipment.find(p => p.productId === product.id);
    if (config) {
      const preselected = [];

      config.preselectedEquipment.forEach(preEquip => {
        const category = equipmentData.equipments.find(e => e.id === preEquip.equipmentId);
        if (category) {
          preEquip.selectedOptions.forEach(preOpt => {
            const option = category.options.find(o => o.id === preOpt.optionId);
            if (option) {
              const instanceId = Date.now() + Math.random();
              preselected.push({
                ...category,
                instanceId,
                quantity: preOpt.quantity || 1,
                usage: preOpt.usage || option.utilization || 1,
                selectedOption: { ...option, categoryId: category.id }
              });
            }
          });
        }
      });

      setSelectedEquipment(preselected);
    } else {
      setSelectedEquipment([]);
    }
  };


  const handleProductChange = (product) => {
    if (Array.isArray(selectedEquipment) && selectedEquipment.length > 0) {
      if(product.id === selectedProduct.id){return;}
      const currentSignature = selectedEquipment
        .map(e => `${e.id}-${e.selectedOption?.id}-${e.quantity}-${e.usage}`)
        .sort()
        .join(',');
      const preselectCurrentProduct = preselectedEquipment.find(p => p.productId === selectedProduct.id)?.preselectedEquipment || [];
      const currentPreselectSignature = preselectCurrentProduct
        .flatMap(e => e.selectedOptions.map(opt => `${e.equipmentId}-${opt.optionId}-${opt.quantity || 1}-${opt.usage || 1}`))
        .sort()
        .join(',');
      if (currentSignature === currentPreselectSignature) {
        setSelectedProduct(product);
        loadDefaultEquipments(product);
        return;
      }
      setPendingProduct(product);
      setShowConfirm(true);
    } else {
      setSelectedProduct(product);
      loadDefaultEquipments(product);
    }
  };

  const handleConfirmReplace = () => {
    if (pendingProduct) {
      setSelectedProduct(pendingProduct);
      loadDefaultEquipments(pendingProduct);
      setPendingProduct(null);
    }
    setShowConfirm(false);
  };

  const handleConfirmKeep = () => {
    if (pendingProduct) {
      setSelectedProduct(pendingProduct);
      setPendingProduct(null);
    }
    setShowConfirm(false);
  };

  useEffect(() => {
    handleProductChange(equipmentData.products[0]);
  }, []);

  const updateConsumption = (newConsumption) => {
    setConsumption(newConsumption);
  };

  return (
    <div className="App solar-theme">
      <HeroSection onContactClick={() => setShowContactForm(true)} onScrollToCarousel={scrollToCarousel} />
        {/* <Header /> */}
      <div ref={productCarouselRef}>
          <ProductCarousel 
            products={equipmentData.products} 
            selectedProduct={selectedProduct} 
            onProductChange={handleProductChange} 
          />
      </div>
      <Container>
        <ProductSelector 
          products={equipmentData.products} 
          selectedProduct={selectedProduct} 
          onProductChange={handleProductChange} 
        />
        <EnergyStats 
          production={selectedProduct.puissance} 
          consumption={consumption} 
        />
        <EquipmentList 
          equipment={equipmentData.equipments} 
          onEquipmentSelect={setSelectedEquipment}
          selectedEquipment={selectedEquipment}
          updateConsumption={updateConsumption}
          consumption={consumption}
          selectedProduct={selectedProduct}
          onQuoteClick={() => setShowQuoteForm(true)}
        />
        <BackToTop hidden={showContactForm || showQuoteForm} />
        <ContactIcon onContactClick={() => setShowContactForm(true)}  hidden={showContactForm || showQuoteForm}/>
        <Contact isOpen={showContactForm} onClose={() => setShowContactForm(false)} />
        <Quote isOpen={showQuoteForm} onClose={() => setShowQuoteForm(false)} selectedProduct={selectedProduct} selectedEquipment={selectedEquipment} />
      </Container>
      
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Changer de produit</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Vous avez déjà sélectionné des équipements.  
          Voulez-vous <b>remplacer</b> votre sélection par la configuration par défaut du nouveau produit,  
          ou <b>conserver</b> vos équipements actuels ?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleConfirmKeep}>
            Conserver mes équipements
          </Button>
          <Button variant="danger" onClick={handleConfirmReplace}>
            Remplacer par défaut
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default App;